import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import apiClient from "../api/apiClient";
import Select from "react-select";
import DataTable from "react-data-table-component";

const ActualizarOrders = () => {
    const [file, setFile] = useState(null);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [project, setproject] = useState("");
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchItems();
    }, []);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);
            setMessage(null);
        } catch (err) {
            console.error("Error obteniendo artículos", err);
            setError("Error al obtener los artículos.");
        }
    };

    const fetchInsumos = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get("/logistica/rutas", {
                params: { project: project?.value }
            });
            console.log("Datos recibidos:", response.data);
            setFilteredOrders(response.data);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = () => {
        if (filteredOrders.length === 0) {
            setError("No hay datos para exportar.");
            return;
        }

        // Convertir los datos a hoja Excel
        const worksheet = XLSX.utils.json_to_sheet(filteredOrders);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Rutas");

        // Generar archivo y descargar
        XLSX.writeFile(workbook, "RutasAsignadas.xlsx");

        // Vaciar el DataTable
        setFilteredOrders([]);
        setproject(null);
    };


    const handleUpload = async () => {
        if (!file) {
            setError("Por favor, selecciona un archivo Excel.");
            return;
        }

        try {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = async (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                const formattedData = {
                    Rutas: jsonData.map(row => ({
                        Code: row["Code"],
                        U_Ruteo: String(row["U_Ruteo"])
                    }))
                };

                const response = await apiClient.patch("/logistica/rutas", formattedData);
                const { results } = response.data;

                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) messageText += `${successCount} rutas actualizadas con éxito.\n`;
                if (warningCount > 0) messageText += `${warningCount} rutas sin cambios.\n`;
                if (errorCount > 0) messageText += `${errorCount} errores.\n`;

                setMessage(messageText);
                setError("");
                setFile(null);
                document.getElementById("fileUpload").value = "";
            };
        } catch (err) {
            setError("Error al procesar el archivo.");
            setMessage("");
        }
    };

    const columns = [
        { name: "ID Registro", selector: row => row.Code, sortable: true },
        { name: "ID Escuela", selector: row => row.U_CntctCode },
        { name: "Nombre", selector: row => row.Name },
        { name: "Ruta", selector: row => row.U_Ruteo },
        { name: "Proyecto", selector: row => row.U_Project }
    ];

    return (
        <div className="container mt-4">
            <h2>Asignación de Rutas</h2>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row align-items-start">
                {/* COLUMNA IZQUIERDA */}
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">Código de Proyecto:</label>
                        <Select
                            options={projects}
                            value={project}
                            onChange={setproject}
                            placeholder="Seleccione un proyecto..."
                            isSearchable
                        />
                    </div>

                    <div className="d-flex gap-2">
                        <button className="btn btn-success" onClick={fetchInsumos}>
                            Obtener Datos
                        </button>
                        <button className="btn btn-outline-secondary" onClick={exportToExcel}>
                            Exportar a Excel
                        </button>
                    </div>
                </div>

                {/* DIVISOR Y COLUMNA DERECHA */}
                <div className="col-md-6 border-start">
                    <div className="mb-3">
                        <label className="form-label">Seleccionar archivo</label>
                        <input
                            type="file"
                            id="fileUpload"
                            className="form-control"
                            accept=".xlsx"
                            onChange={handleFileChange}
                        />
                    </div>

                    <button className="btn btn-primary mt-2" onClick={handleUpload}>
                        Subir y Actualizar Rutas
                    </button>
                </div>
            </div>

                <hr className="my-4" />

                {/* TABLA */}
                <DataTable
                    columns={columns}
                    data={filteredOrders}
                    pagination
                />
        </div>
    );
};

export default ActualizarOrders;
